import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { Select } from '../../General/Select';
import { FlexCol, FlexRow, FlexRowCenterVertical } from '../../../..';
import { FormWrapper, FormInput } from '../../Form/FormInput';
import { DsiCheckBox as CheckBox } from '../../General/Checkbox';
import { CompanyInfo } from './CompanyInfo';
import { prop } from '../../../../utilities';
import { CompanyInfoB2B } from './CompanyInfoB2B';

interface Props {
  isCompany: boolean;
  billingAddress: any;
  company: any;
  onBillingBlur: (updatedData: any) => void;
  onCompanyBlur: (updatedData: any) => void;
  billing_company: boolean;
  use_delivery_address: boolean;
  handleFieldChange: (e: any) => void;
  formProblems: any;
  isB2B: boolean;
  lang: string;
}

function reducer(state, { field, value }) {
  return { ...state, [field]: value };
}

function BillingAddressB2B({
  billingAddress,
  company,
  onBillingBlur,
  onCompanyBlur,
  billing_company,
  use_delivery_address,
  handleFieldChange,
  formProblems,
  isB2B,
  lang,
}: Props) {
  const initialBillingAddressState = getInitialBillingState(billingAddress);
  const [billingAddressState, dispatchBilling] = React.useReducer(
    reducer,
    initialBillingAddressState,
  );
  const initialCompanyState = getInitialCompanyState(company);
  const [companyState, dispatchCompany] = React.useReducer(
    reducer,
    initialCompanyState,
  );

  const {
    nameProblem,
    streetProblem,
    streetNrProblem,
    cityProblem,
    zipProblem,
  } = {
    nameProblem: prop(formProblems, 'billing_address.person.name'),
    streetProblem: prop(formProblems, 'billing_address.street'),
    streetNrProblem: prop(formProblems, 'billing_address.street_number'),
    cityProblem: prop(formProblems, 'billing_address.city'),
    zipProblem: prop(formProblems, 'billing_address.zip'),
  };

  const {
    name,
    surname,
    street,
    street_number,
    city,
    zip,
    country,
  } = billingAddressState;

  const onChangeBilling = e => {
    const {
      target: { name: fieldName, value },
    } = e;
    dispatchBilling({ field: fieldName, value });
  };

  const onChangeCompany = e => {
    const {
      target: { name: fieldName, value },
    } = e;
    dispatchCompany({ field: fieldName, value });
  };

  const handleBlur = e => {
    onBillingBlur({
      street,
      street_number,
      city,
      zip,
      country,
      person: { name, surname },
    });
  };

  return (
    <Wrapper>
      <NameWrapper>
        <FormInput
          justText={isB2B}
          name={'name'}
          type="text"
          label={__('Meno a priezvisko')}
          value={name}
          required={true}
          marginBottom={16}
          minWidthPx={288}
          marginRight={32}
          onChange={onChangeBilling}
          onBlur={handleBlur}
          validMessage={nameProblem}
          validateAllowedChars={true}
        />
        {/* <FormInput
          name={'surname'}
          type="hidden"
          required={true}
          label={''}
          minWidthPx={0}
          value={' '}
          marginBottom={16}
          onChange={onChangeBilling}
          onBlur={handleBlur}
        /> */}
      </NameWrapper>
      <AddressWrapper isB2B={isB2B}>
        <FormWrapper isB2B={isB2B} noWrap={true} marginRight={32}>
          <FormInput
            justText={isB2B}
            name="street"
            type="text"
            label={__('Ulica')}
            value={isB2B ? `${street} ${street_number}` : street}
            maxWidth={100}
            maxWidthPx={320}
            required={true}
            marginRight={0}
            onChange={onChangeBilling}
            onBlur={handleBlur}
            validMessage={streetProblem}
            validateAllowedChars={true}
          />
          {/* <FormInput
            type="hidden"
            name="street_number"
            label={__('Číslo')}
            value={street_number}
            maxWidth={34}
            required={true}
            maxWidthPx={80}
            onChange={onChangeBilling}
            onBlur={handleBlur}
            validMessage={streetNrProblem}
          /> */}
        </FormWrapper>
        <FormWrapper isB2B={isB2B} noWrap={true}>
          <FormInput
            justText={isB2B}
            name="city"
            type="text"
            label={__('Mesto')}
            value={city}
            maxWidth={100}
            maxWidthPx={224}
            marginRight={16}
            required={true}
            onChange={onChangeBilling}
            onBlur={handleBlur}
            validMessage={cityProblem}
            validateAllowedChars={true}
          />
        </FormWrapper>{' '}
        <FormWrapper isB2B={isB2B} noWrap={true}>
          <FormInput
            justText={isB2B}
            name="zip"
            type="text"
            label={__('PSČ')}
            value={zip}
            maxWidth={34}
            maxWidthPx={80}
            required={true}
            onChange={onChangeBilling}
            onBlur={handleBlur}
            validMessage={zipProblem}
            validateAllowedChars={true}
          />
        </FormWrapper>
      </AddressWrapper>
      <Select
        justText={isB2B}
        marginBottom={32}
        name="country"
        label={__('Krajina')}
        value={country}
        required={true}
        options={
          lang === 'cz'
            ? [{ value: 'cz', name: __('Česká republika') }]
            : [{ value: 'sk', name: 'Slovensko' }]
        }
        // tslint:disable-next-line:jsx-no-lambda
        onChange={onChangeBilling}
        onBlur={handleBlur}
      />
      {!isB2B && (
        <CheckBox
          name="billing_company"
          onClick={handleFieldChange}
          selected={billing_company}
          label={__('Nakupujem na firmu')}
        />
      )}
      <CompanyInfoB2B
        company={companyState}
        onChange={onChangeCompany}
        onBlur={onCompanyBlur}
        isVisible={billing_company}
        problems={prop(formProblems, 'company')}
        isB2B={isB2B}
      />
      {!isB2B && (
        <CheckBox
          name="use_delivery_address"
          onClick={handleFieldChange}
          selected={use_delivery_address}
          label={__('Dodacia adresa je iná ako fakturačná adresa')}
        />
      )}
    </Wrapper>
  );
}

const getInitialBillingState = (billingAddress: any) => {
  return {
    name: prop(billingAddress, 'person.name', ''),
    surname: prop(billingAddress, 'person.surname', ' ') || ' ',
    street: prop(billingAddress, 'street', ''),
    street_number: prop(billingAddress, 'street_number', ''),
    city: prop(billingAddress, 'city', ''),
    zip: prop(billingAddress, 'zip', ''),
    country: prop(billingAddress, 'country', 'sk'),
  };
};

const getInitialCompanyState = (company: any) => {
  return {
    companyName: prop(company, 'name', ''),
    dic: prop(company, 'dic', ''),
    ic_dph: prop(company, 'ic_dph', ''),
    ico: prop(company, 'ico', ''),
  };
};

const Wrapper = styled(FlexCol)``;

const NameWrapper = styled(FlexRow)`
  flex-flow: row wrap;
`;

const AddressWrapper = styled(FlexRowCenterVertical)<{ isB2B?: boolean }>`
  flex-flow: ${({ isB2B }) => (isB2B ? 'column' : 'row wrap')};
  align-items: ${({ isB2B }) => (isB2B ? 'flex-start' : 'center')};
`;

export { BillingAddressB2B };
